<template>
  <section class="partnership-container">
    <header>
      <div class="top-bar">
        <span>Corporate Partnership Inquiry</span>
      </div>
      <h2>{{ detailData.company_name }}</h2>
    </header>
    <div class="main-container flex-sb">
      <div class="main-content flex-1">
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Company Name</span>
            <span>{{ detailData.company_name }}</span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span>{{ detailData.business_registration_no }}</span>
          </div>
          <div class="tr">
            <span>Business Nature</span>
            <span>{{ getGlobalOptionName('industry', detailData.business_nature) }}</span>
          </div>
        </div>
        <h3>Person In Charge Detail</h3>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Name</span>
            <span>{{ detailData.person_name }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ detailData.person_email }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span>{{ detailData.person_phone }}</span>
          </div>
        </div>
        <h3>Documents</h3>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(item, index) in businessFile"
            :key="index"
            class="tr">
            <span>Business Registration</span>
            <span
              class="blue pointer"
              @click="openFile(item.url)">
              {{ item.client_name }}
            </span>
          </div>
          <div
            v-for="(item) in personFile"
            :key="item.id"
            class="tr">
            <span>Person In Charge Name Card</span>
            <span
              class="blue pointer"
              @click="openFile(item.url)">
              {{ item.client_name }}
            </span>
          </div>
        </div>
      </div>
      <div class="right-container">
        <v-button
          type="danger"
          @click="handlerDelete">Delete Inquiry</v-button>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {deletePartnership, getPartnershipDetail} from '@/api/partnership'

export default {
  name: 'PartnershipDetail',
  mixins: [MixinOptions],
  data() {
    return {
      detailData: {},
    }
  },
  computed: {
    partnershipId() {
      return this.$route.query.partnership_id
    },
    businessFile() {
      let list = []
      for(let i = 1; i <= 6; i++) {
        let item = this.detailData[`business_registration_file_${i}`]
        if(item) {
          list.push(item)
        }
      }
      return  list
    },
    personFile() {
      let list = []
      for(let i = 1; i <= 6; i++) {
        let item = this.detailData[`person_card_file_${i}`]
        if(item) {
          list.push(item)
        }
      }
      return  list
    },
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getPartnershipDetail()
      }
    }
  },
  methods: {
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    handlerDelete() {
      this.network().deletePartnership()
    },
    network() {
      return {
        getPartnershipDetail: async () => {
          const { data } = await getPartnershipDetail({
            id: this.partnershipId
          })
          this.detailData = data
        },
        deletePartnership: async () => {
          const { data } = await deletePartnership({
            id: this.partnershipId
          })
          this.$message({
            type: 'success',
            message: data.message
          })
          this.$router.replace({
            path: '/administration/partnership'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.partnership-container {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: -20px;
  height: 100%;
  color: #303133;
  header {
      padding: 20px 20px 0 20px;
      background: white;
      border-bottom: 1px solid #DDDFE7;
      h2 {
          padding: 5px 0 15px 0;
      }
  }
  .main-container {
      flex: 1;
      margin-bottom: -40px;
      .right-container {
          padding: 15px;
          width: 250px;
          border-left: 1px solid #DDDFE7;
          background: white;
      }
      .main-content {
        //   max-height: 100%;
        padding: 20px;
          overflow-y: auto;
      }
  }
  .top-bar {
    padding-top: 5px;
    color: #556270;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #556270;
  }
}
</style>
